export const isCrawlerRegExp =
    /bingbot|chrome-lighthouse|cxensebot|facebookexternalhit|facebot|google \(\+https:\/\/developers\.google.com\/\+\/web\/snippet\/\)|googlebot|mediapartners-google|msnbot|twitterbot|yahoocachesystem|ysearch/i

export const checkIsNativeApp = () =>
    typeof navigator !== 'undefined' && navigator.userAgent.includes('bonanza')
